import { useEffect, useState } from 'react';

interface ViewportDimensions {
	aspectRatio: number;
	idealWidth: number;
	idealHeight: number;
}

export const useViewportAspectRatio = (): ViewportDimensions => {
	const [dimensions, setDimensions] = useState<ViewportDimensions>({
		aspectRatio: 16 / 9,
		idealWidth: 1920,
		idealHeight: 1080,
	});

	useEffect(() => {
		const updateDimensions = () => {
			const width = window.innerWidth;
			const height = window.innerHeight;
			const aspectRatio = width / height;

			// Calculate ideal dimensions based on viewport
			// We want to maintain high quality while being efficient
			const idealWidth = Math.min(1920, Math.max(1280, width));
			const idealHeight = Math.round(idealWidth / aspectRatio);

			setDimensions({
				aspectRatio,
				idealWidth,
				idealHeight,
			});
		};

		// Initial calculation
		updateDimensions();

		// Add resize listener
		window.addEventListener('resize', updateDimensions);

		// Cleanup
		return () => {
			window.removeEventListener('resize', updateDimensions);
		};
	}, []);

	return dimensions;
};
